import React from "react";
import { Circles } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../utils/patientUtils";
import VisibilityIcon from "@mui/icons-material/Visibility";

interface InvoicesTabProps {
  invoicesData: any[];
  loading: boolean;
  theme?: "light" | "dark";
}

const InvoicesTab: React.FC<InvoicesTabProps> = ({
  invoicesData,
  loading,
  theme = "light",
}) => {
  console.log(invoicesData);
  const navigate = useNavigate();
  if (loading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Circles height="30" width="30" color="#6366f1" ariaLabel="loading" />
      </div>
    );
  }

  if (invoicesData.length === 0) {
    return (
      <div className={`text-center py-8 rounded-lg ${
        theme === "dark" ? "bg-slate-700/50" : "bg-slate-50"
      }`}>
        <p className={theme === "dark" ? "text-slate-400" : "text-slate-500"}>No invoices found</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h4 className={`text-sm font-semibold mb-3 ${
          theme === "dark" ? "text-slate-300" : "text-slate-700"
        }`}>Invoices</h4>
        <div className="overflow-x-auto -mx-3 sm:mx-0">
          <div className="min-w-full inline-block align-middle">
            <table className="w-full min-w-[800px]">
              <thead>
                <tr className={`border-b ${
                  theme === "dark" ? "border-slate-700" : "border-slate-200"
                }`}>
                  <th className={`text-left py-2 px-2 sm:px-3 text-[10px] sm:text-xs font-semibold uppercase ${
                    theme === "dark" ? "text-slate-300" : "text-slate-700"
                  }`}>Invoice No</th>
                  <th className={`text-left py-2 px-2 sm:px-3 text-[10px] sm:text-xs font-semibold uppercase ${
                    theme === "dark" ? "text-slate-300" : "text-slate-700"
                  }`}>Patient</th>
                  <th className={`text-left py-2 px-2 sm:px-3 text-[10px] sm:text-xs font-semibold uppercase ${
                    theme === "dark" ? "text-slate-300" : "text-slate-700"
                  }`}>Total</th>
                  <th className={`text-left py-2 px-2 sm:px-3 text-[10px] sm:text-xs font-semibold uppercase ${
                    theme === "dark" ? "text-slate-300" : "text-slate-700"
                  }`}>Discount</th>
                  <th className={`text-left py-2 px-2 sm:px-3 text-[10px] sm:text-xs font-semibold uppercase ${
                    theme === "dark" ? "text-slate-300" : "text-slate-700"
                  }`}>Paid</th>
                  <th className={`text-left py-2 px-2 sm:px-3 text-[10px] sm:text-xs font-semibold uppercase ${
                    theme === "dark" ? "text-slate-300" : "text-slate-700"
                  }`}>Balance</th>
                  <th className={`text-left py-2 px-2 sm:px-3 text-[10px] sm:text-xs font-semibold uppercase ${
                    theme === "dark" ? "text-slate-300" : "text-slate-700"
                  }`}>Status</th>
                  <th className={`text-left py-2 px-2 sm:px-3 text-[10px] sm:text-xs font-semibold uppercase ${
                    theme === "dark" ? "text-slate-300" : "text-slate-700"
                  }`}>Date</th>
                  <th className={`text-center py-2 px-2 sm:px-3 text-[10px] sm:text-xs font-semibold uppercase ${
                    theme === "dark" ? "text-slate-300" : "text-slate-700"
                  }`}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {invoicesData.map((item: any, i: number) => {
                  console.log(item);
                  const status = item?.due === 0 ? "Completed" : item?.due > 0 ? "Due" : "Paid";
                  return (
                    <tr key={i} className={`border-b ${
                      theme === "dark" ? "border-slate-700/50 hover:bg-slate-700/30" : "border-slate-100 hover:bg-slate-50"
                    } transition-colors`}>
                      <td className={`py-2 px-2 sm:px-3 text-[10px] sm:text-xs ${
                        theme === "dark" ? "text-slate-300" : "text-slate-600"
                      }`}>
                        {item?.invoiceNo || "N/A"}
                      </td>
                      <td className={`py-2 px-2 sm:px-3 text-[10px] sm:text-xs ${
                        theme === "dark" ? "text-slate-300" : "text-slate-600"
                      }`}>
                        {item?.fullName || "N/A"}
                      </td>
                      <td className={`py-2 px-2 sm:px-3 text-[10px] sm:text-xs font-medium ${
                        theme === "dark" ? "text-slate-200" : "text-slate-800"
                      }`}>
                        Rs {item?.total || 0}
                      </td>
                      <td className={`py-2 px-2 sm:px-3 text-[10px] sm:text-xs ${
                        theme === "dark" ? "text-slate-300" : "text-slate-600"
                      }`}>
                        Rs {item?.discount || 0}
                      </td>
                      <td className={`py-2 px-2 sm:px-3 text-[10px] sm:text-xs font-medium ${
                        theme === "dark" ? "text-slate-200" : "text-slate-800"
                      }`}>
                        Rs {item?.paid || 0}
                      </td>
                      <td className={`py-2 px-2 sm:px-3 text-[10px] sm:text-xs font-medium ${
                        theme === "dark" ? "text-slate-200" : "text-slate-800"
                      }`}>
                        Rs {item?.due || 0}
                      </td>
                      <td className="py-2 px-2 sm:px-3">
                        <span className={`px-1.5 sm:px-2 py-0.5 rounded-md text-[10px] sm:text-xs font-medium ${
                          status === "Completed"
                            ? theme === "dark"
                              ? "bg-emerald-900/30 text-emerald-300"
                              : "bg-emerald-100 text-emerald-700"
                            : status === "Due"
                            ? theme === "dark"
                              ? "bg-red-900/30 text-red-300"
                              : "bg-red-100 text-red-700"
                            : theme === "dark"
                            ? "bg-blue-900/30 text-blue-300"
                            : "bg-blue-100 text-blue-700"
                        }`}>
                          {status}
                        </span>
                      </td>
                      <td className={`py-2 px-2 sm:px-3 text-[10px] sm:text-xs ${
                        theme === "dark" ? "text-slate-300" : "text-slate-600"
                      }`}>
                        {item?.updatedAt ? formatDate(item.updatedAt.split("T")[0]) : "N/A"}
                      </td>
                      <td className="py-2 px-2 sm:px-3 text-center">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            if (item?._id) {
                              navigate(`/client/payments/invoice/${item._id}`);
                            }
                          }}
                          className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all focus:outline-none focus:ring-2 focus:ring-offset-1 ${
                            theme === "dark"
                              ? "bg-indigo-900/30 text-indigo-300 hover:bg-indigo-900/50 focus:ring-indigo-500"
                              : "bg-indigo-50 text-indigo-600 hover:bg-indigo-100 active:bg-indigo-200 focus:ring-indigo-500"
                          }`}
                          title="View Invoice"
                          aria-label="View invoice details"
                        >
                          <VisibilityIcon sx={{ fontSize: 16 }} />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoicesTab;

